export default __webpack_public_path__ + "static/media/profile-picture.e5117e8e.png";